import React from "react";
import { connect } from "react-redux";
import Artwork from "src/components/Artwork";
import * as State from "src/redux/projects/state";
import * as StateCurrentResponses from "src/redux/currentResponses/state";
import * as CurrentReponses from "src/redux/currentResponses";
import { Profil } from "src/redux/user";

interface Props {
  proposal: State.ProposalArtwork;
  projectName: string;
  prestationName: string;
  profil: Profil;
  currentResponses: StateCurrentResponses.CurrentResponse[];
  handleSubmitProposal: (
    response: State.GenericalResponse | undefined,
    share?: boolean,
    newDevis?: boolean
  ) => void;
}
interface State {
  isLocked: boolean;
  loader: boolean;
}

function mapDispatchToProps(dispatch) {
  return {
    setCurrentProposalResponseCommentForArtwork: (
      proposalUuid: string,
      id: string,
      x: number,
      y: number,
      text: string,
      files: State.AttachFile[]
    ) =>
      dispatch(
        CurrentReponses.setCurrentProposalResponseForArtwork(
          proposalUuid,
          id,
          x,
          y,
          text,
          files
        )
      ),
    removeCommentFromArtworkProposal: (
      proposalUuid: string,
      commentId: string
    ) =>
      dispatch(
        CurrentReponses.removeCommentFromArtworkProposal(
          proposalUuid,
          commentId
        )
      ),
    setCurrentProposalResponsePayloadForArtwork: (
      proposalUuid: string,
      payload: State.PayloadArtwork
    ) =>
      dispatch(
        CurrentReponses.setCurrentProposalResponsePayloadForArtwork(
          proposalUuid,
          payload
        )
      ),
    setCurrentProposalResponseType: (
      proposalUuid: string,
      responseType: State.ResponseTypes
    ) =>
      dispatch(
        CurrentReponses.setCurrentProposalResponseType(
          proposalUuid,
          responseType
        )
      ),
    createEmptyArtworkResponse: (proposal: State.ProposalArtwork) =>
      dispatch(CurrentReponses.createEmptyArtworkResponse(proposal)),
    removeCurrentProposalResponse: (proposalUuid: string) =>
      dispatch(CurrentReponses.removeCurrentProposalResponse(proposalUuid))
  };
}

type PropsWithMapState = ReturnType<typeof mapDispatchToProps> & Props;

class ArtworkContainerToConnect extends React.Component<
  PropsWithMapState,
  State
> {
  state = {
    isLocked: this.props.proposal.status !== State.ProposalStatus.Pending,
    loader: false
  };

  /**
   * Create an empty response if not already existing
   */
  componentWillMount() {
    if (!this.getCurrentResponse() && !this.state.isLocked) {
      this.props.createEmptyArtworkResponse(this.props.proposal);
    }
  }
  getCurrentResponse() {
    const currentResponse = this.props.currentResponses.find(
      r => r.proposalUuid === this.props.proposal.uuid
    );

    return currentResponse ? currentResponse.response : undefined;
  }
  // add a comment
  handleSubmitCommentForArtwork = (
    id: string,
    comment: State.ProposalComment
  ) => {
    if (this.state.isLocked) {
      return;
    }

    this.props.setCurrentProposalResponseCommentForArtwork(
      this.props.proposal.uuid,
      id,
      comment.x,
      comment.y,
      comment.text,
      comment.files ? comment.files : []
    );
  };

  removeCommentFromArtworkProposal = (
    proposalUuid: string,
    commentId: string
  ) => {
    if (this.state.isLocked) {
      return;
    }

    this.props.removeCommentFromArtworkProposal(proposalUuid, commentId);
  };

  handleSubmit = async (
    payload: State.PayloadArtwork,
    response: State.ResponseArtwork,
    responseType: State.ResponseTypes,
    share?: boolean,
    newDevis?: boolean
  ) => {
    this.setState({
      loader: true
    });
    this.props.setCurrentProposalResponseType(
      this.props.proposal.uuid,
      responseType
    );

    this.props.setCurrentProposalResponsePayloadForArtwork(
      this.props.proposal.uuid,
      payload
    );

    // Generate a reponse object to send to api
    const payloadForApi = Object.assign({}, response.payload, payload,);
    const responseForApi = {
      ...response,
      payload: payloadForApi,
      responseType
    };
    await this.props.handleSubmitProposal(responseForApi, share,newDevis);
  };

  renderDisplayComponent() {
    return (
      <Artwork
        onSubmit={this.handleSubmit}
        response={this.getCurrentResponse() as State.ResponseArtwork} // Possiblement undefined
        handleSubmitCommentForArtwork={this.handleSubmitCommentForArtwork}
        removeArtwork={this.removeCommentFromArtworkProposal}
        proposal={this.props.proposal}
        isLocked={this.state.isLocked}
        loader={this.state.loader}
        profil={this.props.profil}
      />
    );
  }

  render() {
    if (!this.props.proposal) {
      return null;
    }
    return this.renderDisplayComponent();
  }
}

export const ArtworkContainer = connect(
  null,
  mapDispatchToProps
)(ArtworkContainerToConnect);



// WEBPACK FOOTER //
// ./src/containers/ArtworkContainer.tsx